import type { AuthContextValue } from '@shared/components/AuthProvider/AuthProvider.context';
import type { EventMembership } from '@shared/components/AuthProvider';
import { EventUserStatus } from '@graphql/generated-base';

export const authToUserDetails = (auth: AuthContextValue, eventMemberships: ReadonlyArray<EventMembership>) => {
  return {
    isLoggedIn: auth.isLoggedIn,
    ownedEventWebsite: eventMemberships?.find(event => event.status === EventUserStatus.owner)?.event?.website,
  };
};
